/**
 * Some constants doesn't use, it's future feature
 *
 * @type {boolean}
 */
export const isFirefox = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase().indexOf('firefox') > 0 : false;

export const eventTypes = {
    keydown: 'keydown',
    keyup: 'keyup',
};

const keyMap = {
    backspace: 8,
    tab: 9,
    clear: 12,
    enter: 13,
    return: 13,
    esc: 27,
    escape: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    del: 46,
    delete: 46,
    ins: 45,
    insert: 45,
    home: 36,
    end: 35,
    pageup: 33,
    pagedown: 34,
    capslock: 20,
    '⇪': 20,
    ',': 188,
    '.': 190,
    '/': 191,
    '`': 192,
    '-': isFirefox ? 173 : 189,
    '=': isFirefox ? 61 : 187,
    ';': isFirefox ? 59 : 186,
    '\'': 222,
    '[': 219,
    ']': 221,
    '\\': 220,
};

const modifier = {
    '⇧': 16,
    shift: 16,
    '⌥': 18,
    alt: 18,
    option: 18,
    '⌃': 17,
    ctrl: 17,
    control: 17,
    '⌘': isFirefox ? 224 : 91,
    cmd: isFirefox ? 224 : 91,
    command: isFirefox ? 224 : 91,
};
const modifierMap = {
    16: 'shiftKey',
    18: 'altKey',
    17: 'ctrlKey',
};
const mods = {16: false, 18: false, 17: false};

// F1~F12
for (let k = 1; k < 20; k += 1) {
    keyMap[`f${k}`] = 111 + k;
}

// Firefox
modifierMap[isFirefox ? 224 : 91] = 'metaKey';
mods[isFirefox ? 224 : 91] = false;

export {
    keyMap,
    modifier,
    modifierMap,
    mods,
};
